class BaseForm extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
		this.fields = [];

        this.phonePattern = /^(?:\+?1)?[-. ]?\(?[2-9][0-8][0-9]\)?[-. ]?[2-9][0-9]{2}[-. ]?[0-9]{4}$/i;

        this.$phone = this.$('input[name="phone"]');
        this.$email = this.$('input[name="email"]');
	}

	init() {
		this.hasRecapcha = this.$('#recaptcha').length > 0;
		this.formOptions = {
			form_scope: this,
			debug: false,
			fields: this.fields,
			onValidationSuccess: this.onValidationSuccess,
			onSuccess: $.proxy(this.formSuccessHandler, this),
			onError: $.proxy(this.formErrorHandler, this),
		};

		if(this.hasRecapcha){
			this.formOptions.recaptcha =  {
				id: 'recaptcha',
				options: {
				'sitekey' : SETTINGS.RECAPTCHA,
				'theme'    : 'light'
				}
			}
		}


		if(this.hasRecapcha){
			if(window.onloadRecaptchaReady){
				this.initForm();
			}
		} else{
			this.initForm();
		}

		this.addEvents();
	}

	addEvents() {
		if(this.hasRecapcha) {
			Me.dispatch.subscribe('onloadRecaptchaReady', () => {
				this.initForm();
			})
		}
	}

	removeEvents() {
		if(this.hasRecapcha) {
			Me.dispatch.unsubscribe('onloadRecaptchaReady', () => {
				this.initForm();
			})
		}
	}

	initForm(e, params){
		this.form = new Me.form(this.$el, this.formOptions);
		Me.dispatch.emit('form.initialized', this, {form: this.$el});
	}

    handlePhoneState(){
        let regex = this.phonePattern;

        if(!regex.test(this.$phone.val())){
            if(this.$email.val() != ''){
                this.form.removeField('phone');
                this.$phone.removeClass('error');
            }
        } else{
            this.form.removeField('phone');
            this.form.addField({name: 'phone', type: 'phone'});

            this.form.removeField('email');
            this.$email.removeClass('error');
        }

        this.setMinimumOnRequiredField();
    }

    handleEmailState(){
        let regex = this.phonePattern;

        if(this.$email.val() == ''){
            if(regex.test(this.$phone.val())){
                this.form.removeField('email');
                this.$email.removeClass('error');
            }
        } else{
            this.form.removeField('email');
            this.form.addField({name: 'email', type: 'email'});

            this.form.removeField('phone');
            this.$phone.removeClass('error');
        }

        this.setMinimumOnRequiredField();
    }

	onValidationSuccess(fields) {
		if (this.debug) {console.info(this.dname, "onValidationSuccess");}
		var field;
		for (var fieldKey = 0; fieldKey < fields.length; fieldKey++) {
			field = fields[fieldKey];
			this.handleValidationSuccessField(field);
		}

		if (this.$messages) {
			this.$messages.find('.error').addClass('hide');
			this.$messages.find('.error-none').removeClass('hide');
		}

		if(this.recaptcha) {
			if (!grecaptcha.getResponse(this.grecaptcha)) {
				this.$form.find('#' + this.recaptcha.id).parent().addClass('captcha-error');
				return;
			} else {
				this.$form.find('#' + this.recaptcha.id).parent().removeClass('captcha-error');
			}
		}
        if(this.$btn) {
            this.$btn.removeClass('loading-complete').addClass('loading');
        }

		if (this.tracker_name) {this.trackingMessages.onValidationSuccess.call(this);}
		if (this.ajax) {this.handleAjaxSend(this.utils.reformatFormData.call(this, this.$form.serializeArray()));}
		return this;
	};

	formSuccessHandler(formScope, data){
		this.$el.addClass('success');

		if(!this.$el.hasClass('contact-form')){
			setTimeout(()=>{
				this.$el.removeClass('success');
			}, 5000);
		}

        this.doTracking();

		this.form.reset();

		if(this.form.$btn){
            this.form.$btn.removeClass('loading').addClass('loading-complete');
		}
	}

	formErrorHandler(formScope, error){
		this.$el.addClass('error');

		setTimeout(()=>{
			this.$el.removeClass('error');
		}, 5000);

        if(this.form.$btn){
            this.form.$btn.removeClass('loading').addClass('loading-complete');
        }

	}

    setMinimumOnRequiredField(){
        let regex = this.phonePattern;

        if((!regex.test(this.$phone.val()) && this.$email.val() === '') || (regex.test(this.$phone.val()) && this.$email.val() !== '')){
            this.form.removeField('email');
            this.form.removeField('phone');
            this.form.addField({name: 'email', type: 'email'});
            this.form.addField({name: 'phone', type: 'phone'});
        }
    }

    doTracking(){
		return false;
	}
	//
	// handleSubmitAnimation(e){
	// 	this.form.$btn.removeClass('loading-complete').addClass('loading');
	// }
}